import { createSlice } from '@reduxjs/toolkit';
import { adminRequestOperation } from './adminPanel-operations';
import { AdminPanelState } from './AdminPanelTypes';

const initialState: AdminPanelState = { loading: {}, error: {}, data: {} };

const adminPanelSlice = createSlice({
  name: 'adminPanel',
  initialState,
  reducers: {
    clearAdminRequestError: (state, { payload }: { payload: string }) => {
      state.error[payload] = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(adminRequestOperation.pending, (state, action) => {
        state.loading[action.meta.arg.key] = true;
        state.error[action.meta.arg.key] = null;
      })
      .addCase(adminRequestOperation.fulfilled, (state, action) => {
        state.loading[action.payload.key] = false;
        state.data[action.payload.key] = action.payload.data;
      })
      .addCase(adminRequestOperation.rejected, (state, action) => {
        const key = action.payload?.key || action.meta.arg.key;
        state.loading[key] = false;
        state.error[key] = action.payload?.message || action.error.message || 'Ошибка запроса';
      });
  },
});

export const { clearAdminRequestError } = adminPanelSlice.actions;
export default adminPanelSlice.reducer;
